import { useState } from 'react';
import axios from 'axios';
import TourDetails from "./TourDetails";
import TechService from './TechService';

export default function TabTech(props) {

  const [chosenService, setChosenService] = useState();
  const [techData, setTechData] = useState();

  const [fade, setFade] = useState(false)
  let content;

  const triggerFade = () => {
    setFade(prevState => {
      return !prevState
    })
  }

  const clearService = () => {
    setChosenService(null);
    setTechData(null);
  }


  if (props.tech.length == 0) {
    content = <div><h3 className="ui inverted block header">Technik <i className={(fade ? 'loading disabled ' : '') + 'circular small icon refresh tour-refresh'} onAnimationEnd={triggerFade} onClick={e => { props.getTechData(); triggerFade(); }}></i></h3><div className="ui yellow message" style={{ marginTop: 2 + 'em' }}><div className="header">Für Sie sind keine Aufträge vorhanden.</div><p>Bitten wenden Sie sich an Ihren Disponenten.</p></div></div>;
  }
  else {
    if (chosenService == null) {
      const items = props.tech.map(item => 
      (item.service.execution_tstamp!==null || item.service.cancel_tstamp!==null) ? null :
      <div className="event" onClick={() => setChosenService(item)}>
        <div className={(item.service.execution_tstamp===null ? (item.service.cancel_tstamp===null ? "" : "red") : "green") + " label"} data-text={1}></div>
        <div className="content">
          <div className="summary">
            <a className="header">{item.machine.serial_number}, {item.machine.device_number}</a>
          </div>
          <div class="description">
            {item.site.name} {item.site.description}
          </div>
          <div className="meta">
            <a className="like">
              {item.machine.type}
            </a>
            <a className="priority">
              {item.service.priority}
            </a>
          </div>
        </div>
      </div>);
      let filteredItem=items.filter((itemContent) => itemContent!==null);
      content = filteredItem.length==0 ?
      <div><h3 className="ui inverted block header">Technik <i className={(fade ? 'loading disabled ' : '') + 'circular small icon refresh tour-refresh'} onAnimationEnd={triggerFade} onClick={e => { props.getTechData(); triggerFade(); }}></i></h3><div className="ui yellow message" style={{ marginTop: 2 + 'em' }}><div className="header">Für Sie sind keine Aufträge vorhanden.</div><p>Bitten wenden Sie sich an Ihren Disponenten.</p></div></div>
      :
      <div><h3 className="ui inverted block header">Technik <i className={(fade ? 'loading disabled ' : '') + 'circular small icon refresh tour-refresh'} onAnimationEnd={triggerFade} onClick={e => { props.getTechData(); triggerFade(); }}></i></h3><div className="ui divided feed">{filteredItem}</div></div>;
    }
    else {
      content = <TechService service={chosenService} clearService={clearService} techData={techData} setServiceQueue={props.setServiceQueue} />
    }
  }

  return (
    <div>
      {content}
    </div>
  );
}